var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "documents-tab mt-3",
    attrs: {
      "show": _vm.documentsLoading,
      "opacity": "0",
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, _vm._l(_vm.documentDescriptors, function (descriptor) {
    return _c('div', {
      key: descriptor.usageType,
      staticClass: "document-row"
    }, [_c('div', {
      staticClass: "document-copy"
    }, [_c('h3', {
      staticClass: "document-title"
    }, [_vm._v(" " + _vm._s(descriptor.label) + " ")]), _c('p', {
      staticClass: "document-file-name"
    }, [_vm.hasExcelTemplate(descriptor.usageType) ? [_c('button', {
      staticClass: "document-link document-link-button",
      attrs: {
        "type": "button",
        "disabled": _vm.downloadingExcelTemplate
      },
      on: {
        "click": _vm.onDownloadExcelTemplate
      }
    }, [_vm._v(" " + _vm._s(_vm.getDocumentFileName(descriptor.usageType)) + " ")]), _vm.downloadingExcelTemplate ? _c('b-spinner', {
      attrs: {
        "small": "",
        "variant": "primary"
      }
    }) : _vm._e()] : _vm.getDocumentFileName(descriptor.usageType) ? _c('a', {
      staticClass: "document-link",
      attrs: {
        "href": _vm.getSystemDocumentLink(descriptor.usageType),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(_vm.getDocumentFileName(descriptor.usageType)) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('admin.documents.no-file')) + " ")])], 2)]), _c('div', {
      staticClass: "document-actions"
    }, [_c('input', {
      staticClass: "document-input",
      attrs: {
        "id": `document-upload-${descriptor.usageType}`,
        "type": "file",
        "accept": descriptor.accept,
        "disabled": _vm.uploadingDocuments[descriptor.usageType]
      },
      on: {
        "change": function ($event) {
          return _vm.onFileChange($event, descriptor);
        }
      }
    }), _c('label', {
      staticClass: "upload-trigger",
      attrs: {
        "for": `document-upload-${descriptor.usageType}`
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "paperclip"
      }
    }), _c('span', [_vm._v(_vm._s(descriptor.uploadLabel))])], 1), _vm.uploadingDocuments[descriptor.usageType] ? _c('b-spinner', {
      attrs: {
        "small": "",
        "variant": "primary"
      }
    }) : _vm._e()], 1)]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }